export default "__VITE_ASSET__BToTsDFl__"